<template lang="">
  <el-menu
    unique-opened
    :default-active="$route.path"
    class="el-menu-SideNav"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b"
    router
    :collapse="pageWidth < 768"
  >
    <el-menu-item index="/Overview">
      <i class="el-icon-info"></i>
      <span>概览</span>
    </el-menu-item>
    <el-submenu index="/BasicSettings" v-if="jurisdiction != 'Appraiser'">
      <template slot="title">
        <i class="el-icon-menu"></i>
        <span>基础设置</span>
      </template>
<el-menu-item-group>
  <el-menu-item index="/BasicSettings/Coupon">充值卡片</el-menu-item>
  <el-menu-item index="/BasicSettings/Carousel">轮播图</el-menu-item>
</el-menu-item-group>
</el-submenu>
<el-submenu index="/StoreInformation">
  <div slot="title">
    <i class="el-icon-document"></i>
    <span>门店信息</span>
  </div>
  <el-menu-item-group>
    <el-menu-item index="/StoreInformation/StoreOrderList">订单列表</el-menu-item>
    <el-menu-item index="/StoreInformation/ProductCategory">产品类目</el-menu-item>
  </el-menu-item-group>
</el-submenu><el-submenu index="/StoreSettings">
  <div slot="title">
    <i class="el-icon-setting"></i>
    <span>门店设置</span>
  </div>
  <el-menu-item-group>
    <el-menu-item index="/StoreSettings/StoreInfoSetting"
      v-if="this.$route.params.StoreInfoSettingData">用户设置</el-menu-item>
    <el-menu-item index="/StoreSettings/IncreasePermissions" v-if="jurisdiction != 'Appraiser'">用户列表</el-menu-item>
    <el-menu-item index="/StoreSettings/AppraiserAccounts" v-if="jurisdiction != 'Appraiser'">鉴定师账目</el-menu-item>
    <el-menu-item index="/StoreSettings/UserWallet" v-if="jurisdiction != 'Appraiser'">用户主次钱包</el-menu-item>
  </el-menu-item-group>
</el-submenu>
<el-submenu index="/UserSettings">
  <div slot="title">
    <i class="el-icon-user"></i>
    <span>用户设置</span>
  </div>
  <el-menu-item-group>
    <el-menu-item index="/UserSettings/ChangePassword">修改密码</el-menu-item>
  </el-menu-item-group>
</el-submenu>

<div class="version" v-show="pageWidth > 768"> 
    <i class="el-icon-info">当前版本：v1.1.10</i> 
</div>
<div class="tips" v-show="pageWidth > 768">
  <a target="_blank" href="https://beian.miit.gov.cn/" style="color: #8f8f8f; font-size: small">
    粤ICP备2026020001号-1
  </a>
</div>
</el-menu>
</template>
<script>
import * as auth from "@/utils/auth";
export default {
  name: "SideNav",
  data() {
    return {
      pageWidth: document.documentElement.clientWidth,
      jurisdiction: "",
    };
  },
  methods: {
    // handleOpen(key, keyPath) {
    //   console.log(key, keyPath,);
    // },
    // handleClose(key, keyPath) {
    //   console.log(key, keyPath);
    // }, 
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.pageWidth = document.documentElement.clientWidth;
    });
    this.$nextTick(() => {
      if (
        auth.getAdminInfo("adminInfo").data.userInfo.type == 0
      )
        this.jurisdiction = "Admin";
      else this.jurisdiction = "Appraiser";
    });
  },
};
</script>
<style scoped>
/* 侧边导航栏 */
.el-menu {
  height: 100%;
}

.el-menu-SideNav {
  z-index: 1500;
}

.el-menu-SideNav a {
  color: white;
  text-decoration: none;
}

.el-menu-SideNav span {
  font-size: larger;
}

.version {
  position: absolute;
  bottom: 3%;
  color: #8f8f8f;
  width: 100%;
  text-decoration: none;
  text-align: center;
  z-index: -11;
  font-size: small;
  margin-bottom: 5px;
}

.tips {
  position: absolute;
  bottom: 1%;
  color: white;
  width: 100%;
  text-decoration: none;
  text-align: center;
  z-index: -11;
}
</style>
